import { Button } from '@/components/ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { trackSignupIntent, trackDemoRequest, buildSignupURL } from '@/utils/analytics';

const SIGNUP_URL = 'https://my.tdfxcapital.net/portal';

export const CTASection = () => {
  const handleSignup = () => {
    trackSignupIntent('footer_cta', 'website');
    const url = buildSignupURL(SIGNUP_URL, 'footer_live_account');
    window.open(url, '_blank');
  };

  const handleDemo = () => {
    trackDemoRequest('footer_demo_button');
    const url = buildSignupURL(SIGNUP_URL, 'footer_demo', { demo: 'true' });
    window.open(url, '_blank');
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Ready to Start Trading?
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-2xl mx-auto font-light">
            Join thousands of traders who trust TD Capital. Open your account in minutes.
          </p>
          
          {/* Trust badges */}
          <div className="flex flex-wrap items-center justify-center gap-6 mb-10 text-sm">
            <div className="flex items-center gap-2 text-gray-300">
              <CheckCircle className="h-5 w-5 text-green-400" />
              <span>Free Demo Account</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <CheckCircle className="h-5 w-5 text-green-400" />
              <span>No Hidden Fees</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300">
              <CheckCircle className="h-5 w-5 text-green-400" />
              <span>Instant Withdrawals</span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              size="lg"
              className="btn-premium text-white font-semibold text-base px-10 h-14"
              onClick={handleSignup}
              data-testid="cta-signup-btn"
            >
              Open Live Account
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="text-base px-10 h-14 bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold"
              onClick={handleDemo}
              data-testid="cta-demo-btn"
            >
              Try Free Demo
            </Button>
          </div>
          
          {/* Urgency text */}
          <p className="text-sm text-gray-400 mt-6">
            Start trading in under 5 minutes. No minimum deposit required.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;